import { Link } from 'react-router-dom';
import { categories } from '@/mocks/data';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-200">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 max-w-7xl mx-auto">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4 cursor-pointer">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-vidicon-fill text-background-50 text-lg"></i>
              </div>
              <span className="text-lg font-heading font-bold text-background-50 whitespace-nowrap">
                榴莲视频
              </span>
            </Link>
            <p className="text-sm text-background-400 leading-relaxed">
              您的一站式在线视频平台导航与评测站点，帮助您找到最适合的在线影视平台。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">内容分类</h4>
            <ul className="space-y-2">
              {categories.map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-400 hover:text-background-200 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">热门平台</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/article/1" className="text-sm text-background-400 hover:text-background-200 transition-colors cursor-pointer">榴莲视频</Link>
              </li>
              <li>
                <Link to="/article/2" className="text-sm text-background-400 hover:text-background-200 transition-colors cursor-pointer">丝瓜视频</Link>
              </li>
              <li>
                <Link to="/article/3" className="text-sm text-background-400 hover:text-background-200 transition-colors cursor-pointer">蓝莓视频</Link>
              </li>
              <li>
                <Link to="/article/5" className="text-sm text-background-400 hover:text-background-200 transition-colors cursor-pointer">糖心视频</Link>
              </li>
              <li>
                <Link to="/article/11" className="text-sm text-background-400 hover:text-background-200 transition-colors cursor-pointer">黑桃视频</Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">关于我们</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/about" className="text-sm text-background-400 hover:text-background-200 transition-colors cursor-pointer">品牌介绍</Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-400 hover:text-background-200 transition-colors cursor-pointer">用户口碑</Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-400 hover:text-background-200 transition-colors cursor-pointer">联系我们</Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-800 mt-10 pt-8 max-w-7xl mx-auto">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-sm text-background-500">
              &copy; {new Date().getFullYear()} 榴莲视频. 保留所有权利.
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-sm text-background-500 hover:text-background-300 transition-colors cursor-pointer" rel="nofollow">隐私政策</a>
              <a href="#" className="text-sm text-background-500 hover:text-background-300 transition-colors cursor-pointer" rel="nofollow">服务条款</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}